<i18n>
{
  "cl": {
    "titleInteractions":"Historial de interacciones",
    "labeldateFilterFrom": "Desde",
    "labeldateFilterTo": "Hasta",
    "null": "No aplica",
    "yes": "Sí",
    "no":"No",
    "phono":"Télefono",
    "no-interactions-to-show": "No hay registros para mostrar",
    "PHONE": "Teléfono",
    "EMAIL": "Email",
    "SMS": "Mensaje de texto",
    "VISIT": "Visita en terreno",
    "error-getContactMethods":"Ocurrió un error al tratar de obtener los medios de contactos disponibles",
    "managedBy": "Actualmente está siendo gestionado por",
    "notBeingManaged": "No estás habilitado para gestionar este cliente"
  },
  "pe": {
    "titleInteractions":"Historial de interacciones",
    "labeldateFilterFrom": "Desde",
    "labeldateFilterTo": "Hasta",
    "null": "No aplica",
    "yes": "Sí",
    "no":"No",
    "phono":"Télefono",
    "no-interactions-to-show": "No hay registros para mostrar",
    "PHONE": "Teléfono",
    "EMAIL": "Email",
    "SMS": "Mensaje de texto",
    "VISIT": "Visita en terreno",
    "error-getContactMethods":"Ocurrió un error al tratar de obtener los medios de contactos disponibles",
    "managedBy": "Actualmente está siendo gestionado por",
    "notBeingManaged": "No estás habilitado para gestionar este cliente"
  },
  "br": {
    "titleInteractions":"Histórico de interações",
    "labeldateFilterFrom": "A partir de",
    "labeldateFilterTo": "Até",
    "null": "Não se aplica",
    "yes": "Sím",
    "no":"Não",
    "phono":"Telefone",
    "no-interactions-to-show": "Não há registros para mostrar",
    "PHONE": "Teléfono",
    "EMAIL": "Email",
    "SMS": "Mensagem de texto",
    "VISIT": "Viagem ao campo",
    "error-getContactMethods":"Ocorreu um erro ao tentar obter os meios de contato disponíveis",
    "managedBy": "Atualmente está sendo atuado por",
    "notBeingManaged": "Você não está autorizado a gerenciar este cliente"
  }
}
</i18n>
<template>
  <div class="card-item">
    <Spinner :is-loading="isLoading" />
    <div v-if="!errorMessageForUser && !isLoading" class="interaction-card">
      <div class="interactions-history">
        <h3>
          {{ $t('titleInteractions') }}
          <b-button
            id="show-add-interaction-form"
            :disabled="!checkUserFeature('element.collectings.button.add-interaction')"
            class="is-pulled-right"
            :class="showNewInteractionForm ? 'is-button-primary' : 'is-primary'"
            :icon-right="showNewInteractionForm ? 'times' : 'comment-medical'"
            @click="showNewInteractionForm = !showNewInteractionForm" />
        </h3>
        <template v-if="!showNewInteractionForm">
          <div v-if="useDateFilters" class="date-filter med-size-text">
            <div>
              <label>{{ $t('labeldateFilterFrom') }}:</label>
              <b-datepicker
                id="datepicker-from"
                v-model="currentDateConstraints.from"
                size="is-small"
                rounded
                label="Desde"
                locale="es-ES" />
            </div>
            <div>
              <label>{{ $t('labeldateFilterTo') }}:</label>
              <b-datepicker
                id="datepicker-to"
                v-model="currentDateConstraints.to"
                size="is-small"
                rounded
                locale="es-ES" />
            </div>
          </div>
          <Message
            v-if="!interactions || interactions.length === 0"
            :as-card="false"
            :message="$t('no-interactions-to-show')"
            icon="Information_flow.svg" />
          <div v-else class="backoffice-interactions">
            <div
              v-for="(interaction, interactionIndex) in interactions"
              :key="interaction._id"
              class="interaction card-item shadowless"
              :class="extendedClientDefault === interactionIndex ? 'details-showed' : ''">
              <div
                class="interaction-header"
                @click="extendedClientDefault === interactionIndex ?
                  extendedClientDefault = undefined : extendedClientDefault = interactionIndex">
                <div class="interaction-header-contact">
                  <i
                    class="fas content-title big-size-text"
                    :class="contactMethodsMap[`${interaction.contactMethod}`] && contactMethodsMap[`${interaction.contactMethod}`].icon
                      ? contactMethodsMap[`${interaction.contactMethod}`].icon
                      : 'fa-comment-slash'" />
                  <div class="header-date med-size-text">
                    <span>{{ formatDate(interaction.createdAt).split(" ")[0] }}</span>
                    <span>{{ formatDate(interaction.createdAt).split(" ")[1] }}</span>
                  </div>
                </div>
                <div class="interaction-header-user">
                  <span class="content-title med-size-text">{{ interaction.createdBy.name }}</span>
                  <span class="small-size-text">{{ interaction.createdBy.email }}</span>
                  <span v-if="interaction.isImportant"><i class="fas fa-star has-text-warning" /></span>
                </div>
                <div class="interaction-header-details">
                  <span
                    class="fa content-title big-size-text"
                    :class="extendedClientDefault === interactionIndex ? 'fa-minus-circle' : 'fa-plus-circle'" />
                </div>
              </div>
              <div
                class="interaction-details"
                :class="extendedClientDefault === interactionIndex ? 'show' : 'hide'">
                <div class="interaction-details-comment">{{ interaction.comment }}</div>
                <div class="interaction-details-complements">
                  <span v-for="field in fields" :key="field.name" class="control">
                    <span class="tag is-info is-light">{{ field.title }}</span>
                    <span v-if="!field.useDictionary && field.type === 'select'" class="tag is-light">{{ $t(getTextFromBoolean(interaction[field.name])) }}</span>
                    <span v-if="field.type === 'datepicker'" class="tag is-light">{{ interaction[field.name] || $t('null') }}</span>
                    <span v-if="field.type === 'text'" class="tag is-light">{{ interaction[field.name] || $t('null') }}</span>
                    <span v-if="field.title === 'Status' && field.useGlobalTrad" class="tag is-light">{{ $t(`prospectStatus.${interaction[field.name] || 'null'}`) }}</span>
                    <span v-if="field.title === 'Sub-Status' && field.useGlobalTrad" class="tag is-light">{{ $t(`prospectSubStatus.${interaction[field.name] || 'null'}`) }}</span>
                    <span v-if="field.name === 'availabilityInitialHour'" class="tag is-light">{{ interaction[field.name] || $t('null') }}</span>
                    <span v-if="field.name === 'availabilityEndHour'" class="tag is-light">{{ interaction[field.name] || $t('null') }}</span>
                    <span v-if="field.useDictionary && !field.useGlobalTrad" class="tag is-light">{{ $t(interaction[field.name] || 'null') }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <template v-if="showNewInteractionForm">
        <AddInteractionForm
          v-if="(managingType === 'SINGLE' && currentBackofficeRelatedUser._id === currentUserId) || managingType === 'MULTIPLE'"
          :contact-methods="contactMethods"
          :fields.sync="fields"
          @create-new-interaction="$emit('create-new-interaction', $event)" />
        <div v-else>
          <h4 v-if="currentBackofficeRelatedUser">
            {{ $t('managedBy') }}
            {{ currentBackofficeRelatedUser.name }}
            <small class="has-text-grey">({{ currentBackofficeRelatedUser.email }})</small>
          </h4>
          <h4 v-else>
            <small class="has-text-grey">({{ notBeingManaged }})</small>
          </h4>
        </div>
      </template>
    </div>
    <Message v-else-if="errorMessageForUser" :message="errorMessageForUser" icon="data_maintenance.svg" />
  </div>
</template>
<script>
import Spinner from '@/ui/components/Spinner.vue';
import Message from '@/ui/components/Message.vue';
import { getContactMethods } from '@/application/services/api-clients/clients';
import { dateToFormatedString } from '@/infrastructure/date';
import AddInteractionForm from '@/ui/components/interactions/AddInteractionForm.vue';
import userFeatures from '@/ui/mixins/user-features';

export default {
  name: 'InteractionsHistory',
  components: { Message, Spinner, AddInteractionForm },
  // mixins: [userFeatures],
  props: {
    currentBackofficeRelatedUser: { default: () => ({}) },
    managingType: { default: 'MULTIPLE' }, // ['SINGLE'||'MULTIPLE']
    fields: { default: () => [] },
    interactions: { default: () => [] },
    loadingInteractions: { default: false },
    useDateFilters: { default: false },
    dateConstraints: { default: () => ({}) }
  },
  data() {
    const { _id: currentUserId } = this.$store.state.currentUser.user;
    return {
      currentUserId,
      errorMessageForUser: '',
      contactMethods: [{ slug: null, name: this.$t('null') }],
      contactMethodsMap: {},
      extendedClientDefault: '',
      showNewInteractionForm: false,
      currentDateConstraints: this.dateConstraints,
      loadingContactMethods: true
    };
  },
  computed: {
    isLoading: {
      get() { return this.loadingInteractions || this.loadingContactMethods; },
      set(newValue) { return newValue; }
    }
  },
  watch: {
    currentDateConstraints: {
      immediate: false,
      deep: true,
      handler() {
        this.requestToLoadInteractions();
      }
    }
  },
  async mounted() {
    await this.getAndSetContactMethods();
    // this.requestToLoadInteractions();
    this.$parent.$on('new-interaction-successfully-created', () => {
      this.requestToLoadInteractions();
      this.showNewInteractionForm = false;
    });
  },
  methods: {
    // Por algún motivo el mixins no funciona en este modulo.
    checkUserFeature(name) {
      return userFeatures.methods.checkUserFeature(name, this.$store);
    },
    async getAndSetContactMethods() {
      this.loadingContactMethods = true;
      try {
        const fetched = (await getContactMethods()).map(({ slug, icon }) => ({ slug, icon, name: this.$t(`${slug}`) }));
        this.contactMethods.push(...fetched);
        this.contactMethods.forEach(x => {
          this.contactMethodsMap[x.slug] = x;
        });
        const contactMethodField = this.fields.find(({ name }) => name === 'contactMethod');
        contactMethodField.possibleOptions = this.contactMethods;
      } catch (_error) {
        // TODO: make translation work here :)
        // this.errorMessageForUser = this.$t('error-getContactMethods');
        this.errorMessageForUser = 'Ocorreu um erro ao tentar obter os meios de contato disponíveis';
        this.isLoading = false;
      }
      this.loadingContactMethods = false;
    },
    getTextFromBoolean(boolean) {
      if (boolean === null) {
        return 'null';
      }
      if (boolean) {
        return 'yes';
      }
      return 'no';
    },
    formatDate: val => dateToFormatedString(val, 'DD/MM/YYYY HH:mm'),
    requestToLoadInteractions() {
      let dateConstraints;
      if (this.useDateFilters) {
        dateConstraints = {
          from: this.currentDateConstraints.from.toISOString().substring(0, 10),
          to: this.currentDateConstraints.to.toISOString().substring(0, 10)
        };
      }
      this.$emit('load-interactions', dateConstraints);
    }
  }
};
</script>
<style scoped>
.card-item {
  overflow: visible !important;
  z-index: 1;
}
.big-size-text { font-size: 1.3rem; }
.med-size-text { font-size: 1.1rem; }
.small-size-text { font-size: 0.9rem }
.content-title { color: var(--primary); }
.hide { display: none; }
.interaction-card {
  padding: 0 2%;
}
.interactions-history {margin: 0rem 0rem 2rem 0rem;}
.interactions-history > div {margin-bottom: 1rem;}
.date-filter {
  display: grid;
  grid-template-columns: repeat( auto-fit, minmax(8rem, 1fr));
  gap: 2rem;
}
.backoffice-interactions {
  display: flex;
  flex-flow: column wrap;
  gap: 1rem;
}
.interaction.card-item {
  border-radius: 3rem;
  padding: 0rem;
}
.interaction.card-item.details-showed {border-radius: 1.5rem;}
.interaction-header {
  width: 100%;
  padding: 2% 3%;
  display: grid;
  grid: "contact info extend" auto / minmax(auto, 14rem) auto 1rem;
  place-items: center start;
  gap: 1rem;
}
.interaction-header .interaction-header-contact,
.interaction-header .interaction-header-user {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  justify-items: center;
  align-items: baseline;
  align-content: center;
  gap: 0.5rem 1rem;
}
.interaction-header-contact .header-date {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  justify-items:center;
  align-items:center;
  gap: 0.5rem;
}
.interaction-details {
  height: 0;
}
.interaction-details.show {
  padding: 0% 3% 3% 3%;
  height: auto;
}
.interaction-details-comment {
  background-color: whitesmoke;
  border-radius: 1rem;
  padding: 0.5rem 1rem;
  margin: 0rem 0rem 1rem 0rem;
}
.interaction-details-complements  {
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  gap: 1rem;
}
textarea#comment {border-radius: 1rem;}
@media (max-width: 900px) {
  .big-size-text {font-size: 1.2rem;}
  .med-size-text {font-size: 0.9rem;}
  .small-size-text {font-size: 0.75rem}
}
@media (max-width: 350px) {
  .big-size-text {font-size: 0.9rem;}
  .med-size-text {font-size: 0.75rem;}
  .small-size-text {font-size: 0.6rem}
}
</style>
